export const createAuthApi = (customFetch) => ({
    postEvents: async () => {
        try {
            const response = await customFetch('nextEvents', {
                method: "POST"
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    }
});